<template>
  <div>
    <PageAppBar>{{ title }}</PageAppBar>
    <div class="page-content header-clear-small">
      <div v-if="loading" class="text text-center">
        <mushonga></mushonga>
      </div>
      <div v-else>
        <div class="card card-style preload-img" data-src="images/pictures/27t.jpg" 
        
        :style="'height: 200px; background-image: url(&quot;'+image_url+course.photo+'&quot;);'">
          <div class="card-center text-center">
            
            <h1 class="color-white mt-4">{{ course.title }}</h1>
            <p class="color-white font-12 mt-n2 mb-5">{{ course.description }}</p>
          </div>
          <div class="card-overlay bg-black opacity-80"></div>
        </div>
        <div v-if="course.course_materials !== undefined">
          <div v-for="material in course.course_materials" :key="material.id" class="card card-style mb-3">
            <div class="card card-style mb-3">
              <div class="d-flex">
                <div class="pl-3 ml-2 align-self-center">
                  <h1 class="pt-4">Coaching Courses</h1>
                  <p class="font-11 opacity-50 mt-n2 mb-4">Start learning</p>
                </div>
                <div class="ml-auto mr-4 align-self-center">
                  <p v-if="material.type === 'video'" @click="playVideo(material)" class="font-11 opacity-50 mt-n2 mb-4">
                    <i class="fa fa-play color-blue2-dark fa-3x mt-4 mb-4"></i>
                  </p>
                  <a v-else :href=" file_url + material.link" download="Notes" class="font-11 opacity-50 mt-n2 mb-4">
                    <i class="fa fa-file color-blue2-dark fa-3x mt-4 mb-4"></i>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-else class="card card-style">
          <div class="content mb-2">
            <h3>Details</h3>
            <p class="color-highlight font-12 mt-n2 mb-2">To join this course, pay the required course fee at TBD offices and enroll.</p>
            <div class="divider mt-2 mb-2"></div>
            <div class="d-flex">
              <div class="pt-1">
                <h5 data-activate="question-1" class="font-600">Contribution Amount: USD {{course.cost}}</h5>
              </div>
            </div>
            <div class="divider mt-2 mb-2"></div>
            <div class="d-flex">
              <div class="pt-1">
                <h5 data-activate="question-2" class="font-600">Start Date: {{formatDate(course.start_date)}}</h5>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
    <FooterBar></FooterBar>
  </div>
</template>

<script>
import PageAppBar from "@/components/PageAppBar";
import axios from "axios";
import FooterBar from "@/components/FooterBar";
import global from "@/mixins/global";
import {mapMutations} from "vuex"

export default {
  mixins: [global],
  mounted() {
    this.fetchCourseDetails()
  },
  data(){
    return {
      title: "Course "+this.$route.params.id,
      course:{},
      loading: false
    }
  },
  name: "SingleCourse",
  components: {FooterBar, PageAppBar},
  methods: {
    ...mapMutations(["updateStateVideo"]),
    fetchCourseDetails(){
      this.loading = true
      axios.get(this.base_url+"courses/"+this.$route.params.id, this.requestAuthHeaderToken(localStorage.getItem("token"))).then(response=>{
        this.course = response.data.data
        this.title = this.course.title
        this.loading = false
      }).catch(error=>{
        this.error = error
        this.loading = false
      })
    },
    playVideo(video){
      this.updateStateVideo(video)
      this.$router.push("/course_video")
    
    },

  }
}
</script>

<style scoped>

</style>